import React from "react";
import { DecodedJWT } from './types/ServerDTO';

export enum token_config {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  MANAGE_CASES = 'MCS',
  MANAGE_CONSTITUENTS = 'MCN',
  VIEW_REPORTS = 'REP',
  MANAGE_USERS = 'MUSR',
  MANAGE_OFFICES = 'MOFF',
  REPLY_MESSAGE = 'RPLM',
  MANAGE_TAGS = 'MTAG',
  MANAGE_NEIGHBORHOODS = 'MNGH',
  MANAGE_MS_GRAPH = 'MMSG',
  REPLY_TO_CONSTITUENTS = 'RCN',
  MANAGE_ADDRESS_BOOKS = 'MAB',
  MANAGE_USER_NOTIFICATIONS = 'MUN',
}

export interface AuthTokens {
  accessToken: string | null;
  refreshToken: string | null;
}

export type AppContextType = {
  authTokens: AuthTokens | null;
  setAuthTokens: React.Dispatch<React.SetStateAction<AuthTokens | null>>;
  isLoggedIn: boolean;
  themeVersion: string;
  handleThemeChange: Function;
  isNavOpen: boolean;
  handleShowNav: Function;
  userInfo?: DecodedJWT;
  updateNotificationCount: Function;
  notificationCount: number;
};

export const AppContext = React.createContext<AppContextType>({
  authTokens: null,
  setAuthTokens: () => { },
  isLoggedIn: false,
  themeVersion: "white",
  handleThemeChange: () => { },
  isNavOpen: false,
  handleShowNav: () => { },
  updateNotificationCount: () => { },
  notificationCount: 0,
});

export default AppContext;